import { modes } from "../modes";
import { permissions } from "../permissions/permissions";
import { roles } from "../roles";

export const vendorPermissionProfile = {
    VIEW: {
        [modes.EDIT_PERMISSION]: [permissions.VENDORS.VIEW_VENDORS, permissions.VENDORS.MANAGE_VENDORS],
        // [modes.EDIT]: [roles.OWNER]
    },
    EDIT: {
        [modes.EDIT_PERMISSION]: [permissions.VENDORS.MANAGE_VENDORS],
        // [modes.EDIT]: [roles.OWNER]
    },
    ADD_FEEDBACK: {
        [modes.EDIT_PERMISSION]: [permissions.VENDORS.ADD_FEEDBACK],
        // [modes.EDIT]: [roles.OWNER]
    }
}
